import mitt from 'mitt'

// 使用 Event Bus 事件总线
const $bus = {}
const emitter = mitt()
$bus.on = emitter.on
$bus.emit = emitter.emit
$bus.off = emitter.off

export default $bus;
